import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { useToast } from "../../hooks/use-toast";
import { ExternalLink, Copy, ShieldCheck } from "lucide-react";

export default function ComplianceTrustCenter() {
  const { toast } = useToast();
  const [data, setData] = useState(null);
  const publicUrl = `${window.location.origin}/trust`;

  useEffect(() => { api.get("/trust-center/overview").then((r) => setData(r.data)); }, []);

  const copyLink = () => {
    navigator.clipboard?.writeText(publicUrl);
    toast({ title: "Link copied" });
  };

  return (
    <div className="space-y-4" data-testid="compliance-trust-center-page">
      <div className="rounded-xl border border-primary/30 bg-primary/5 p-4 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <ShieldCheck className="w-4 h-4 text-primary" />
          <div>
            <div className="text-[13px] font-semibold">Your Trust Center is live</div>
            <div className="text-[12px] text-muted-foreground">Share this public page with customers and prospects.</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button size="sm" variant="outline" className="gap-1.5" onClick={copyLink} data-testid="compliance-trust-center-copy-btn">
            <Copy className="w-3.5 h-3.5" /> Copy link
          </Button>
          <Button size="sm" asChild className="gap-1.5" data-testid="compliance-trust-center-view-btn">
            <a href="/trust" target="_blank" rel="noreferrer">
              <ExternalLink className="w-3.5 h-3.5" /> View public page
            </a>
          </Button>
        </div>
      </div>

      {!data ? (
        <div className="h-40 rounded-xl bg-muted/40 animate-pulse" />
      ) : (
        <div className="grid sm:grid-cols-2 gap-3">
          <div className="rounded-xl border border-border bg-card p-4">
            <div className="text-[13px] font-semibold mb-2">Frameworks shown publicly</div>
            <div className="space-y-1.5">
              {data.frameworks.map((f) => (
                <div key={f.key} className="flex items-center justify-between text-[12.5px]">
                  <span>{f.name}</span>
                  <span className="text-muted-foreground">{f.maturity_pct}% — {f.status_label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="rounded-xl border border-border bg-card p-4">
            <div className="text-[13px] font-semibold mb-2">Active vendors shown publicly ({data.vendors.length})</div>
            <div className="flex flex-wrap gap-1.5">
              {data.vendors.map((v) => (
                <span key={v.name} className="text-[11px] rounded-full border border-border bg-muted/40 px-2 py-0.5">{v.name}</span>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
